import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const TechnicalServicePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Set page title and meta tags
    document.title = 'Teknik Servis - Bilgisayar ve Laptop Tamiri | Es Donanım Bilgisayar Ankara';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ankara\'da profesyonel bilgisayar tamiri, laptop tamiri, masaüstü bilgisayar tamiri ve teknik servis hizmeti. Hızlı arıza tespiti, uygun fiyat, garanti. Bireysel ve kurumsal çözümler.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'teknik servis, bilgisayar tamiri, laptop tamiri, masaüstü bilgisayar tamiri, notebook tamiri, bilgisayar servisi, arıza tespiti, bilgisayar onarım, kurumsal teknik servis, ankara bilgisayar tamiri');
    }
    
    // Set canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', `${siteUrl}/teknik-servis`);
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Bilgisayar ve Laptop Teknik Servis",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Es Donanım Bilgisayar",
        "telephone": "+905065376985",
        "email": "info@esbilgisayar.com.tr",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Anafartalar Cad. Ulus Şehir Çarşısı No:3/11",
          "addressLocality": "Altındağ",
          "addressRegion": "Ankara",
          "postalCode": "06030",
          "addressCountry": "TR"
        }
      },
      "areaServed": {
        "@type": "City",
        "name": "Ankara"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Teknik Servis Hizmetleri",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Bilgisayar Tamiri",
              "description": "Masaüstü ve laptop bilgisayar tamiri hizmeti"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Arıza Tespiti",
              "description": "Ücretsiz arıza tespiti ve fiyat teklifi"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Parça Değişimi",
              "description": "Orijinal ve uyumlu yedek parça değişimi"
            }
          }
        ]
      }
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  const serviceProcess = [
    {
      id: 1,
      number: '01',
      title: 'Arıza Tespiti',
      description: 'Bilgisayarınızı getirin, ücretsiz ön inceleme ile arızayı tespit edelim',
      icon: 'ri-search-line',
    },
    {
      id: 2,
      number: '02',
      title: 'Fiyat Teklifi',
      description: 'Şeffaf fiyatlandırma ile tamir maliyetini size bildiriyoruz',
      icon: 'ri-price-tag-3-line',
    },
    {
      id: 3,
      number: '03',
      title: 'Onarım',
      description: 'Uzman ekibimiz hızlı ve garantili şekilde tamiri gerçekleştiriyor',
      icon: 'ri-tools-line',
    },
    {
      id: 4,
      number: '04',
      title: 'Teslimat',
      description: 'Test edilmiş ve garanti belgeli olarak cihazınızı teslim ediyoruz',
      icon: 'ri-checkbox-circle-line',
    },
  ];

  const repairServices = [
    {
      category: 'Donanım Tamiri',
      icon: 'ri-cpu-line',
      services: [
        'Anakart tamiri ve değişimi',
        'Ekran kartı tamiri',
        'Güç kaynağı değişimi',
        'Hard disk / SSD değişimi',
        'RAM yükseltme',
        'Ekran değişimi',
      ],
    },
    {
      category: 'Yazılım Hizmetleri',
      icon: 'ri-code-line',
      services: [
        'Format atma',
        'İşletim sistemi kurulumu',
        'Driver yüklemeleri',
        'Virüs temizleme',
        'Veri kurtarma',
        'Sistem optimizasyonu',
      ],
    },
    {
      category: 'Bakım Hizmetleri',
      icon: 'ri-settings-3-line',
      services: [
        'Fan temizliği',
        'Termal macun değişimi',
        'Genel temizlik',
        'Performans testi',
        'Soğutma sistemi bakımı',
        'Periyodik kontrol',
      ],
    },
    {
      category: 'Kurumsal Destek',
      icon: 'ri-building-line',
      services: [
        'Toplu cihaz bakımı',
        'Ağ kurulumu',
        'Sunucu yönetimi',
        'IT danışmanlık',
        'Yerinde teknik destek',
        'Yıllık bakım sözleşmeleri',
      ],
    },
  ];

  const guarantees = [
    {
      icon: 'ri-shield-check-line',
      title: '12 Ay Garanti',
      description: 'Tüm tamir işlemlerimizde 12 ay garanti veriyoruz',
    },
    {
      icon: 'ri-tools-fill',
      title: 'Orijinal Parça',
      description: 'Sadece orijinal ve uyumlu parçalar kullanıyoruz',
    },
    {
      icon: 'ri-eye-line',
      title: 'Ücretsiz İnceleme',
      description: 'Arıza tespiti ve ön inceleme tamamen ücretsiz',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pb-16 lg:pb-0">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary via-primary-light to-primary">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 font-heading">
                  Profesyonel Teknik Servis
                </h1>
                <p className="text-xl text-white/90 mb-8 leading-relaxed">
                  Bilgisayar tamiri, laptop tamiri, masaüstü bilgisayar tamiri ve notebook tamiri hizmetlerinde uzman kadromuz ile yanınızdayız. Hızlı, güvenilir ve garantili çözümler.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
                  <a
                    href="tel:+905XXXXXXXXX"
                    className="flex items-center justify-center space-x-3 px-8 py-4 bg-secondary hover:bg-secondary-dark text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line text-xl"></i>
                    <span>Hemen Ara</span>
                  </a>
                  <a
                    href="https://wa.me/905XXXXXXXXX"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-3 px-8 py-4 bg-whatsapp hover:bg-whatsapp/90 text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    <span>WhatsApp</span>
                  </a>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://public.readdy.ai/ai/img_res/da8f4e992768ae6f2c8aa7d5fdc2813d.jpg"
                  alt="Teknik Servis"
                  className="w-full h-[500px] object-cover rounded-2xl shadow-card-hover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-24 bg-white">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
                <span className="text-secondary font-semibold text-sm">Servis Süreci</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
                Nasıl Çalışıyoruz?
              </h2>
              <p className="text-neutral-600 text-lg max-w-3xl mx-auto">
                Bilgisayar bakım ve onarım sürecimiz 4 basit adımdan oluşuyor
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {serviceProcess.map((step, index) => (
                <div key={step.id} className="relative">
                  <div className="bg-white rounded-xl p-8 shadow-card hover:shadow-card-hover transition-all text-center">
                    <div className="w-16 h-16 flex items-center justify-center bg-accent/10 rounded-xl mx-auto mb-6">
                      <i className={`${step.icon} text-3xl text-accent`}></i>
                    </div>
                    <div className="text-4xl font-bold text-secondary/20 mb-4">{step.number}</div>
                    <h3 className="text-xl font-bold text-primary mb-3">{step.title}</h3>
                    <p className="text-neutral-600 text-sm leading-relaxed">{step.description}</p>
                  </div>
                  {index < serviceProcess.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                      <i className="ri-arrow-right-line text-3xl text-secondary/30"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-24 bg-neutral-50">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
                <span className="text-secondary font-semibold text-sm">Hizmet Kategorileri</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
                Teknik Servis Hizmetlerimiz
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {repairServices.map((service) => (
                <div
                  key={service.category}
                  className="bg-white rounded-xl p-8 shadow-card hover:shadow-card-hover transition-all"
                >
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-xl">
                      <i className={`${service.icon} text-3xl text-accent`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-primary">{service.category}</h3>
                  </div>
                  <ul className="space-y-3">
                    {service.services.map((item, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <i className="ri-check-line text-secondary text-lg mt-0.5 flex-shrink-0"></i>
                        <span className="text-neutral-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Guarantees Section */}
        <section className="py-24 bg-gradient-to-br from-primary via-primary-light to-primary">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 font-heading">
                Garanti ve Güvencelerimiz
              </h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto">
                Oyuncu bilgisayarı tamiri ve kurumsal bilgisayar servisi dahil tüm hizmetlerimizde
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {guarantees.map((guarantee) => (
                <div
                  key={guarantee.title}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/20 transition-all"
                >
                  <div className="w-16 h-16 flex items-center justify-center bg-secondary/20 rounded-xl mx-auto mb-6">
                    <i className={`${guarantee.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{guarantee.title}</h3>
                  <p className="text-white/90 leading-relaxed">{guarantee.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-white">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
              Bilgisayarınız Arızalı mı?
            </h2>
            <p className="text-xl text-neutral-600 mb-10 max-w-3xl mx-auto">
              Format atma, anakart tamiri, ekran değişimi ve tüm teknik servis ihtiyaçlarınız için hemen iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <a
                href="tel:+905XXXXXXXXX"
                className="flex items-center justify-center space-x-3 px-8 py-4 bg-secondary hover:bg-secondary-dark text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>Hemen Ara</span>
              </a>
              <a
                href="https://wa.me/905XXXXXXXXX"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-3 px-8 py-4 bg-whatsapp hover:bg-whatsapp/90 text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>WhatsApp ile İletişim</span>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default TechnicalServicePage;